/*
 * Dawnスライダー(.slider)にマウスのドラッグ移動（Swiper風のグラブ）を付与する。
 * タッチは overflow の慣性スクロールで既に動くので mouse のみ対象。
 * スクロール軸は縦横どちらでも可（scrollLeft/scrollTop を両方動かすが、
 * オーバーフローの無い軸はクランプされ無害）。
 */
(() => {
  const THRESHOLD = 5;

  function initSlider(el) {
    if (el.dataset.dragInit) return;
    el.dataset.dragInit = '1';

    let down = false;
    let moved = false;
    let startX = 0;
    let startY = 0;
    let sl = 0;
    let st = 0;

    const scrollable = () => el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;

    const begin = (e) => {
      down = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      sl = el.scrollLeft;
      st = el.scrollTop;
    };

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !scrollable()) return;
      begin(e);
    });

    el.addEventListener('pointermove', (e) => {
      if (!down) {
        // pointerdownを取り逃したケースでも、ボタン押下中の移動で開始（通常はpointerdownが先）
        if (e.pointerType !== 'mouse' || e.buttons !== 1 || !scrollable()) return;
        begin(e);
        return;
      }
      if (e.buttons === 0) {
        // pointerupを取り逃した場合の保険
        end();
        return;
      }
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (!moved && Math.hypot(dx, dy) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
        el.style.cursor = 'grabbing';
        el.style.scrollSnapType = 'none';
        // Dawnの .slider は scroll-behavior:smooth のため、連続scroll設定がアニメ化して競合する
        el.style.scrollBehavior = 'auto';
        el.style.userSelect = 'none';
      }
      el.scrollLeft = sl - dx;
      el.scrollTop = st - dy;
      e.preventDefault();
    });

    const end = () => {
      if (!down) return;
      down = false;
      el.style.removeProperty('cursor');
      el.style.removeProperty('scroll-snap-type');
      el.style.removeProperty('scroll-behavior');
      el.style.removeProperty('user-select');
      if (moved) {
        // ドラッグ直後に発火する click（サムネ切替等）を1回だけ握り潰す
        const suppress = (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          el.removeEventListener('click', suppress, true);
        };
        el.addEventListener('click', suppress, true);
        setTimeout(() => el.removeEventListener('click', suppress, true), 50);
      }
    };

    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    el.querySelectorAll('img, a').forEach((n) => n.setAttribute('draggable', 'false'));
  }

  function initAll() {
    document.querySelectorAll('.slider').forEach(initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // テーマエディタのセクション再描画に対応
  document.addEventListener('shopify:section:load', initAll);
})();
